<template>
    <div id="loan-rejection-button">
        <vx-tooltip text="Rechazar proyecto">
            <vs-button @click.stop="showRejectReasonDialog = true" icon="do_not_disturb_alt" color="danger"></vs-button>
        </vx-tooltip>
        <vs-popup class="mid-popup header-primary" title="Motivo de rechazo" :active.sync="showRejectReasonDialog">

            <div class="row">
                <!-- ¿Por qué? -->
                <div class="col-md-12 mb-4">
                    <h6 class="bold mb-4">Categoría</h6>
                    <div class="col-md-12 mb-4">
                        <vs-select class="w-full mb-5" v-model.lazy="categorySelected" name="getCollection"
                            v-validate="'required'" placeholder="Seleccione una opción">
                            <vs-select-item :key="index" :value="item.value" :text="item.text"
                                v-for="(item, index) in rgCategory" class="w-full" />
                        </vs-select>
                    </div>
                    <h6 class="bold mb-4">Razón</h6>
                    <div class="col-md-12 mb-4">
                        <vs-select class="w-full mb-5" v-validate="'required'" name="resolutions"
                            label="Seleccione una opción" :disabled="categorySelected === null"
                            v-model.number="resolutionSelected">
                            <vs-select-item  key="0" value="0" text="Seleccione una opción"></vs-select-item>
                            <vs-select-item :key="index" :value="item.value" :text="item.text"
                                v-for="(item, index) in collections.resolutions" class="w-full" />
                        </vs-select>
                    </div>

                </div>
                <!-- Botones -->
                <div class="col-md-12 mb-4">
                    <div class="ml-4 flex flex-wrap items-center justify-end align-right">
                        <vs-button :disabled="categorySelected === null || resolutionSelected === 0"
                            @click="requestLoanRejection()" color="warning" class="ml-auto mt-2 mr-2">Rechazar
                            proyecto</vs-button>
                        <vs-button @click="closePrompt()" color="danger" class="ml-2 mt-2">Cancelar</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import { mapActions } from 'vuex'

// Razones de rechazo según RG
const rgCategory = [
  {value: "1", text: "Rechazo por modelo de riesgo"}
  , {value: "2", text: "Historial crediticio"}
  , {value: "3", text: "Alto nivel de endeudamiento:"}
  , {value: "4", text: "Resultado “No recomendable” en visita domiciliaria:"}
  , {value: "5", text: "Riesgo en comportamiento de pago de servicios CFE."}
  , {value: "6", text: "Análisis de Solvencia y Veracidad de la Información Financiera"}
  , {value: "7", text: "Falta de documentación de ingresos"}
  , {value: "8", text: "Inestabilidad laboral o económica:"}
  , {value: "9", text: "Documentación incompleta o contradictoria:"}
  , {value: "10", text: "Edad fuera del rango permitido"}
  , {value: "11", text: "Ubicación fuera de zona permitida"}
  , {value: "12", text: "Relación con personas políticamente expuestas (PEP)"}
  , {value: "13", text: "Incumplimiento de políticas del producto o segmento"}
  , {value: "14", text: "Antecedentes judiciales o legales"}
];

export default {
    data: () => ({
        showRejectReasonDialog: false,
        rgCategory: rgCategory,
        categorySelected: null,
        resolutionSelected: 0,
        collections: {
            resolutions: []
        },
        actor: 1,
    }),
    props: {
        loanId: String | Number
    },
    watch: {
        categorySelected: function (event) {
            this.getCollections();
        }
    },
    methods: {
        ...mapActions('projects', [
            'rejectProject',
        ]),
        async requestLoanRejection() {
            if (this.resolutionSelected == 0) {
                this.$toast.error("Debe seleccionar una razón de rechazo");
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: "Confirmar rechazo de crédito",
                text: `¿Estás seguro de rechazar el crédito ${this.loanId}?`,
                acceptText: "Confirmar",
                cancelText: 'Cancelar',
                accept: this.doLoanRejection
            });
        },
        async doLoanRejection() {
            this.showLoading(true, "Rechazando crédito...");
            try {
                await this.rejectProject({
                    id: this.loanId,
                    reason_id: this.resolutionSelected
                });
                swal("Ok!", "¡Los cambios se realizaron correctamente!", "success")
            } catch (e) {
                swal("Upss!", "Hubo un error al rechazar el projecto", "error")
                console.error(e)
            } finally {
                this.showLoading(false);
                window.location.reload();
            }

            
        },
        async getCollections() {
            try {
                const res = await axios.get(`/api/v1/forms/getLoanResolutionByCategory/${this.categorySelected}`);
                let data = res.data;
                this.collections.resolutions = [];
                this.resolutionSelected = 0;

                data.forEach(element => {
                    let obj = {
                        value: element.id,
                        text: element.description
                    }
                    this.collections.resolutions.push(obj);
                });

            } catch (e) {
                this.warn(e);
            }
        },
        resetForm() {
            this.categorySelected = null;
            this.resolutionSelected = null;
        },
        closePrompt() {
            this.resetForm();
            this.collections.resolutions = [];
            this.resolutionSelected = 0;
            this.actor = 1;
            this.showRejectReasonDialog = false;
        }
    }
}
</script>